import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 536.000000 506.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,506.000000) scale(0.100000,-0.100000)">
<path d="M1410 3750 l0 -431 93 3 92 3 3 333 2 332 75 0 75 0 0 -321 0 -322
41 7 c45 7 218 71 233 86 5 6 -10 32 -37 66 l-47 56 0 90 c0 51 4 88 9 86 5
-1 33 -30 61 -63 73 -85 141 -155 149 -155 12 0 131 104 131 115 0 5 -31 44
-68 86 -37 41 -92 104 -122 140 -144 168 -207 222 -337 288 -61 30 -65 31
-208 31 l-145 0 0 -430z"/>
<path d="M3373 4134 c-108 -55 -136 -79 -275 -244 -59 -69 -142 -165 -186
-215 -59 -66 -78 -94 -72 -105 5 -8 34 -40 65 -70 l56 -55 42 46 c23 25 80 89
127 142 46 54 88 97 92 97 4 0 8 -27 8 -61 0 -33 3 -59 8 -57 7 3 56 33 148
90 l44 28 0 130 0 130 75 0 75 0 0 -101 c0 -87 2 -100 15 -95 19 7 110 32 148
40 l27 6 0 170 0 170 -153 0 -153 0 -91 -46z"/>
<path d="M4015 3805 c-30 -19 -54 -25 -98 -25 -69 0 -244 -39 -343 -75 -154
-58 -354 -189 -483 -316 l-44 -43 64 -58 c35 -32 68 -58 72 -58 5 0 39 28 75
61 92 84 171 139 277 192 110 55 192 82 309 102 119 20 139 19 182 -10 63 -43
133 -29 188 35 31 37 35 103 11 151 -36 69 -135 90 -210 44z m140 -60 c41 -40
26 -106 -27 -124 -58 -20 -116 30 -103 89 13 60 86 80 130 35z"/>
<path d="M3700 3471 c-30 -10 -70 -25 -87 -35 l-33 -17 0 -183 c0 -147 3 -185
14 -189 7 -3 50 -9 95 -12 l81 -8 0 232 c0 127 -3 231 -7 230 -5 0 -33 -9 -63
-18z"/>
<path d="M2466 3335 l-60 -54 35 -40 c19 -22 57 -67 84 -100 28 -33 53 -60 58
-60 7 -1 46 40 102 107 l27 32 -83 85 c-45 47 -87 85 -93 85 -6 -1 -38 -25
-70 -55z"/>
<path d="M3390 3303 c-62 -43 -132 -113 -127 -127 5 -14 148 -86 159 -80 10 7
11 224 0 224 -4 0 -19 -8 -32 -17z"/>
<path d="M2218 3167 c-43 -24 -81 -46 -84 -50 -4 -3 36 -53 87 -109 128 -142
224 -249 299 -335 35 -40 66 -73 69 -73 3 1 22 20 41 44 19 24 94 109 165 190
72 81 131 153 133 159 2 10 -119 127 -131 127 -3 0 -51 -52 -108 -116 l-103
-117 -35 39 c-20 22 -67 75 -106 119 -38 44 -88 99 -110 122 l-40 43 -77 -43z"/>
<path d="M1845 3025 l-90 -21 -5 -154 -5 -155 -70 0 -70 0 -3 148 -3 147 -94
0 -95 0 0 -245 0 -245 268 2 267 3 3 264 c1 146 -1 268 -5 271 -5 4 -48 -3
-98 -15z"/>
<path d="M3230 2655 l0 -155 270 0 270 0 0 100 0 100 -62 2 c-35 1 -111 1
-170 -1 -103 -3 -106 -3 -110 19 -2 18 -20 28 -98 56 -52 19 -96 34 -97 34 -2
0 -3 -70 -3 -155z"/>
<path d="M273 1982 l-53 -3 5 -300 c2 -164 7 -304 10 -310 8 -13 115 -10 133
4 9 7 12 53 13 166 0 182 -6 182 95 -3 l60 -111 41 -3 41 -3 48 88 c80 150
106 194 110 190 3 -2 7 -78 10 -168 l5 -164 69 -3 70 -3 0 311 0 310 -72 0
-73 0 -49 -88 c-124 -221 -149 -262 -156 -262 -4 0 -31 42 -60 93 -152 266
-151 265 -180 263 -8 0 -39 -2 -67 -4z"/>
<path d="M1837 1983 l-37 -4 2 -307 3 -307 75 0 75 0 5 163 c3 89 8 163 11
165 4 1 66 -71 139 -161 77 -94 141 -164 154 -168 12 -3 45 -4 72 -2 l49 3 3
275 c1 151 0 290 -3 308 l-6 32 -74 0 -75 0 0 -164 c0 -91 -3 -167 -8 -170 -4
-2 -55 54 -112 126 -58 72 -113 140 -123 152 -63 73 -52 69 -150 59z"/>
<path d="M4522 1981 c-9 -6 -12 -76 -10 -312 l3 -304 245 0 245 0 3 62 3 63
-168 2 -168 3 -3 39 c-5 56 5 89 24 82 9 -3 72 -3 140 0 l124 7 0 58 0 58
-142 3 -143 3 0 55 0 55 50 -3 c28 -1 101 0 163 4 l112 6 0 59 c0 50 -3 59
-17 59 -10 0 -115 2 -233 4 -118 3 -221 2 -228 -3z"/>
<path d="M1080 1784 c0 -107 5 -214 11 -237 17 -69 72 -135 137 -165 48 -22
71 -27 142 -27 138 0 218 49 267 161 13 30 18 78 21 216 2 98 1 194 -2 213
l-7 35 -74 0 -75 0 0 -170 c0 -269 -19 -315 -130 -315 -111 0 -130 45 -130
309 l0 176 -80 0 -80 0 0 -196z"/>
<path d="M2472 1918 l3 -63 98 -3 97 -3 0 -245 0 -245 78 3 77 3 3 242 2 242
98 3 97 3 3 63 3 62 -281 0 -281 0 3 -62z"/>
<path d="M3112 1758 c3 -248 8 -268 76 -334 111 -108 363 -89 444 33 44 67 48
95 48 314 l0 209 -80 0 -80 0 0 -200 c0 -222 -5 -247 -60 -275 -38 -20 -95
-19 -131 2 -50 30 -59 72 -59 283 l0 190 -81 0 -80 0 3 -222z"/>
<path d="M3832 1673 l3 -308 82 -3 82 -3 3 88 3 88 51 3 52 3 57 -91 58 -90
88 0 c49 0 89 2 89 4 0 2 -30 47 -66 101 -36 53 -64 97 -63 99 2 1 19 13 37
25 88 61 103 223 29 307 -62 72 -88 79 -310 82 l-197 4 2 -309z m357 151 c40
-33 43 -89 7 -131 -23 -26 -31 -28 -110 -32 l-86 -3 0 96 0 96 79 0 c71 0 83
-3 110 -26z"/>
<path d="M958 1164 c-5 -4 -8 -85 -8 -181 l0 -173 103 0 c173 1 232 45 232
176 0 62 -3 75 -29 108 -16 21 -45 45 -65 53 -39 17 -221 30 -233 17z m216
-49 c48 -20 76 -67 76 -128 0 -99 -52 -141 -175 -142 l-80 0 -3 143 -3 142 75
0 c43 0 88 -6 110 -15z"/>
<path d="M1592 1158 c-12 -15 -152 -328 -152 -340 0 -4 7 -8 15 -8 8 0 25 20
37 45 l22 45 102 0 101 0 17 -45 c13 -32 23 -45 37 -45 10 0 19 2 19 3 0 6
-126 290 -144 325 -17 34 -37 41 -54 20z m62 -124 c20 -47 36 -90 36 -95 0
-10 -143 -13 -153 -3 -3 3 6 32 20 63 14 31 31 71 39 89 8 17 16 32 18 32 2 0
20 -39 40 -86z"/>
<path d="M1885 1159 c-12 -18 8 -28 65 -31 l55 -3 3 -158 c2 -144 4 -158 20
-155 15 3 17 21 20 160 l3 157 57 3 c43 2 57 7 57 18 0 12 -23 15 -137 18 -92
2 -139 -1 -143 -9z"/>
<path d="M2432 1158 c-12 -16 -152 -331 -152 -344 0 -2 8 -4 19 -4 13 0 24 14
35 45 l18 45 102 0 103 0 17 -45 c13 -32 23 -45 37 -45 10 0 19 3 19 7 0 11
-141 326 -153 341 -5 6 -15 12 -22 12 -7 0 -17 -6 -23 -12z m67 -130 c21 -46
36 -86 34 -90 -8 -14 -153 -9 -153 4 0 21 64 168 73 168 4 0 25 -37 46 -82z"/>
<path d="M2813 1163 c-10 -4 -13 -49 -13 -179 l0 -174 120 0 c99 0 120 3 120
15 0 11 -20 15 -97 17 l-98 3 -3 155 c-1 85 -6 157 -10 161 -4 4 -13 4 -19 2z"/>
<path d="M3227 1164 c-4 -4 -7 -86 -7 -181 0 -161 1 -174 18 -171 15 3 17 20
17 177 0 164 -5 197 -28 175z"/>
<path d="M3474 1157 c-2 -7 -3 -87 -2 -177 3 -148 5 -165 21 -168 15 -3 17 8
17 132 0 75 4 136 9 136 4 0 55 -61 112 -135 64 -84 110 -135 121 -135 17 0
18 14 18 181 0 166 -1 180 -17 177 -16 -3 -19 -20 -23 -143 l-5 -140 -49 65
c-75 99 -160 204 -171 212 -15 11 -25 10 -31 -5z"/>
<path d="M4003 1163 c-10 -4 -13 -49 -13 -179 0 -167 1 -174 20 -174 17 0 20
7 20 43 0 35 7 50 39 87 21 25 41 43 43 40 105 -131 143 -170 160 -170 15 0
18 4 11 13 -5 6 -40 52 -77 100 l-68 89 43 46 c24 25 57 58 73 73 17 16 27 31
23 35 -16 17 -59 -15 -142 -106 -49 -54 -93 -96 -97 -93 -5 2 -8 46 -8 98 0
93 -4 106 -27 98z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
